$(".footer__disclaimer-more").click(function() {
    $(this).remove();
    $(".footer__disclaimer-content--hidden").show();
})
